import { createFileRoute } from '@tanstack/react-router';
import { IntegracoesPage } from '@/components/integracoes';

export const Route = createFileRoute('/_app/configuracoes/integracoes/api')({
  component: IntegracoesApiRota,
});

function IntegracoesApiRota() {
  return <IntegracoesPage />;
}
